import React from 'react';
// import ClassicEditor from '@rastech-inc/ckeditor';
import CollapsibleBody from 'components/Collapsible/CollapsibleBody';
import CKEditorField, {
  CKEditorReadOnlyConfig,
} from '../../CKEditorField/CKEditorField';
import messages from '../Messages';
import {
  FieldChipValue,
  FieldChipWrapper,
  QuestionInfoChildren,
  QuestionInfoTitle,
  QuestionInfoWrapper,
} from './styles';
import { IQuestionField } from 'store/survey/surveyTypes';

interface IComponentProps {
  fields: IQuestionField[] | null;
  hint?: string;
  show: boolean;
}

const QuestionInfo: React.FC<IComponentProps> = ({ show, hint, fields }) => {
  // const [nested, setNested] = useState(true);
  // useEffect(() => {
  //   setTimeout(() => {
  //     setNested(false);
  //   }, 10000);
  // }, []);
  return (
    <CollapsibleBody
      nested={true}
      isOpen={show}
      customBodyStyle={{ padding: '0rem 0' }}
    >
      {hint && (
        <QuestionInfoWrapper>
          <QuestionInfoTitle>{messages.hint}</QuestionInfoTitle>

          <QuestionInfoChildren>
            <div style={{ width: '100%' }}>
              <CKEditorField
                // editor={ClassicEditor}
                data={hint.replace(/\n/g, '<br>')}
                disabled={true}
                dir="rtl"
                config={CKEditorReadOnlyConfig}
              />
            </div>
          </QuestionInfoChildren>
        </QuestionInfoWrapper>
      )}
      {fields && fields.length > 0 && (
        <QuestionInfoWrapper>
          <QuestionInfoTitle>{messages.description}</QuestionInfoTitle>
          <QuestionInfoChildren>
            {fields.map((field) => {
              const value = field.value;
              const name = field.name;
              if (name.startsWith('conf_')) return undefined;
              return (
                <FieldChipWrapper key={`${value}_${name}`} hasValue={!!value}>
                  <span style={{ flex: 1 }}>{name}</span>
                  <span style={{ flex: 4, textAlign: 'start' }}>
                    {value && <FieldChipValue>{value}</FieldChipValue>}{' '}
                  </span>
                </FieldChipWrapper>
              );
            })}
          </QuestionInfoChildren>
        </QuestionInfoWrapper>
      )}
    </CollapsibleBody>
  );
};

export default QuestionInfo;
